/**
 * Auto-setup utilities for LUKSO products
 *
 * Re-exports the canonical implementation from @lukso/up-modal.
 * setupLuksoConnector now returns a LuksoConnector instance with
 * showSignInModal() / closeModal() instead of a plain { wagmiConfig } object.
 */

export type { LuksoConnectorConfig } from '@lukso/up-modal'
export {
  EMBEDDED_WALLET_ID,
  EMBEDDED_WALLET_URL_DEV,
  EMBEDDED_WALLET_URL_PROD,
  LuksoConnector,
  setupLuksoConnector,
  UP_EXTENSION_ID,
} from '@lukso/up-modal'
